require('./creditPregrantedLimitVariationSuccess.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
// @ commons
const { formatText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
// @helpers
const { getLastNChars } = require('utilities/stringHelper');
const { getFormattedString } = require('utilities/currencyHelper');

class CreditPregrantedLimitVariationSuccess extends React.Component {
    getAccountAliasAndNumber(immCredit) {
        const accountNumber = getLastNChars(immCredit.get('iban'), 4, '*', 4);
        return `${immCredit.get('alias')} ${accountNumber}`;
    }

    render() {
        const { immCredit, newLimit } = this.props;
        const isIncrease = newLimit > immCredit.getIn(['limit','amount']);
        const goBackButton = {
            label: formatText('creditPregrantedLimitVariationSuccess-goBackButton'),
            url: '/myprofile/loans-mortgages'
        };
        const amountObject = {
            amount: newLimit,
            currency: immCredit.getIn(['limit','currency'])
        };
        const injectedStrings = [
            this.getAccountAliasAndNumber(immCredit),
            getFormattedString(amountObject)
        ];
        let successMessage;

        if (isIncrease) {
            successMessage = formatText(`creditPregrantedLimitVariationSuccess-messageIncrease`, injectedStrings);
        } else {
            successMessage = formatText(`creditPregrantedLimitVariationSuccess-messageDecrease`, injectedStrings);
        }

        return (
            <article className="credit-pregranted-limit-variation-success">
                <WizardSuccess
                    successMessage={successMessage}
                    mainButton={goBackButton}
                />
            </article>
        );
    }
}

CreditPregrantedLimitVariationSuccess.propTypes = {
    immCredit: PropTypes.object,
    newLimit: PropTypes.number
};

module.exports = CreditPregrantedLimitVariationSuccess;